import React from "react";

function About() {
  return (
    <div className="text-center mo-4">
      <h2 className="h2">About Page</h2>
    </div>
  );
}

export default About;
